import * as React from 'react';

type UseFiltersProps = {
    globalFilterKey?: string;
    globalFilterLabel?: string;
};

function useSearch(props?: UseFiltersProps) {
    const { globalFilterKey = 'search', globalFilterLabel } = props ?? {};
    const [globalFilterState, setGlobalFilterState] = React.useState<string>('');

    const querySearchOptions = React.useMemo(() => {
        const globalFilter = { [globalFilterKey]: globalFilterState };
        return globalFilter;
    }, [globalFilterState]);

    return {
        querySearchOptions,
        globalFilterState,
        setGlobalFilterState,
        globalFilterLabel,
    };
}

export default useSearch;
